import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import InfoMessageApi from '../generated/api/InfoMessage';

export default (service: Servicelayer) => ({
  ...InfoMessageApi(service),

  // Add custom calls here

});
